/**
 * Reveals the computed build cross-sell only where Shopify has nothing curated.
 *
 * Every product page carries a complementary-recommendations section. It is
 * populated for complete scooters and skates and empty for parts — a deck, a
 * bar and two wheels all returned zero when measured. The Liquid block this
 * governs fills that gap by computing the pairing from spec_category.
 *
 * Whoever curated the scooters and skates knew something the computation does
 * not, so the curated answer must win. Liquid cannot know which case it is in:
 * the recommendation endpoint is only consulted in the browser. So the block is
 * rendered hidden and shown here, once the answer is known.
 *
 * Failing means staying hidden. A shopper seeing no cross-sell is a smaller
 * loss than a shopper seeing two.
 */
(function () {
  'use strict';

  var block = document.querySelector('[data-bxs]');
  if (!block) return;

  var host = document.querySelector('product-recommendations[data-intent="complementary"]');
  var productId = host && host.getAttribute('data-product-id');

  /* No complementary section on the page at all — nothing can contradict us. */
  if (!host || !productId) {
    block.hidden = false;
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(
    root +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=4&intent=complementary'
  )
    .then(function (response) {
      if (!response.ok) throw new Error('recs ' + response.status);
      return response.json();
    })
    .then(function (data) {
      var curated = data && data.products ? data.products.length : 0;
      if (curated === 0) block.hidden = false;
    })
    .catch(function () {
      /* Stay hidden rather than risk showing a second cross-sell. */
    });
})();
